import { useMemo } from "react";

import useStorage from "fe-shared/src/hooks/useStorage";
import { getRequestParams } from "fe-shared-transactions/src/helpers/transactionsRequestConverter";
import {
  DataGridFilters,
  DataGridOptions,
} from "fe-shared/src/components/DataGrid/modules/types";

const useTransactionsRequestParams = () => {
  const [options, setOptions] = useStorage<DataGridOptions>(
    "portalTransactionsOptions",
    {
      sortDirection: "desc",
      sortField: "completedDate",
    },
    true
  );
  const [filters, setFilters] = useStorage<DataGridFilters>(
    "portalTransactionsFilters",
    {},
    true
  );

  const requestParams = useMemo(() => getRequestParams(filters, options), [
    filters,
    options,
  ]);

  return {
    options,
    filters,
    setOptions,
    setFilters,
    requestParams,
  };
};

export default useTransactionsRequestParams;
